import { Box, Stack, TextField, Typography, debounce } from "@mui/material";
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { IControlledMutator } from "sonobello.utilities.react";

export const classNames = {
  noteText: "fullNoteEditorNoteText",
  noteTags: "fullNoteEditorNoteTags",
  textArea: "fullNoteEditorTextArea"
};

export interface IFullNoteEditor extends IControlledMutator<string> {
  tags?: string;
}

/** A view and input that renders the full content of note tags and custom text. */
const FullNoteEditor: React.FC<IFullNoteEditor> = ({ tags, value, onChange }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => setLocalValue(value), [value]);

  const debouncedOnChange = useCallback(
    debounce((v: string) => onChange(v), 600),
    []
  );

  const handleChange = ({ target: { value } }: ChangeEvent<HTMLTextAreaElement>) => {
    debouncedOnChange(value.trim());
    setLocalValue(value);
  };

  return (
    <Stack spacing={2}>
      <Box>
        {tags && (
          <Typography className={classNames.noteTags} variant="body2">
            {tags}
          </Typography>
        )}
        <Typography className={classNames.noteText} variant="body2" component="span">
          {localValue}
        </Typography>
      </Box>
      <TextField
        className={classNames.textArea}
        label="Add Note"
        multiline
        fullWidth
        minRows={4}
        maxRows={15}
        value={localValue}
        variant="outlined"
        onChange={handleChange}
      />
    </Stack>
  );
};

export default FullNoteEditor;
